import { useEffect, useState } from 'react'

interface TimeLeft {
  hours: string
  minutes: string
  seconds: string
}

function msUntilMidnight(): number {
  const now = new Date()
  const midnight = new Date(now)
  midnight.setHours(24, 0, 0, 0)
  return Math.max(0, midnight.getTime() - now.getTime())
}

function format(ms: number): TimeLeft {
  const totalSeconds = Math.floor(ms / 1000)
  return {
    hours: String(Math.floor(totalSeconds / 3600)).padStart(2, '0'),
    minutes: String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0'),
    seconds: String(totalSeconds % 60).padStart(2, '0'),
  }
}

/** Counts down to local midnight — the end of today's promo window. */
export function useCountdown(): TimeLeft {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>(() => format(msUntilMidnight()))

  useEffect(() => {
    const id = window.setInterval(() => {
      setTimeLeft(format(msUntilMidnight()))
    }, 1000)
    return () => window.clearInterval(id)
  }, [])

  return timeLeft
}
